import * as mitt from 'mitt';
const $event = (mitt.default || mitt)();
function on(eventId, fn) {
    $event.on(eventId, fn);
    return () => {
        $event.off(eventId, fn);
    };
}
function once(eventId, fn) {
    const sub = () => {
        $event.off(eventId, sub);
        fn();
    };
    $event.on(eventId, sub);
}
function emit(eventId, data) {
    $event.emit(eventId, data);
}
function removeAllListeners(eventId) {
    $event.off(eventId);
}
export const event = {
    on,
    once,
    emit,
    removeAllListeners,
};
//# sourceMappingURL=event.js.map